import React from 'react';
import PropTypes from 'prop-types';
import AppLoaderSC from './app-loader.styled';
import AppSpinnerSC from './app-spinner.styled';
import AppSpinnerModalSC from './app-spinner-modal.styled';

class AppLoader extends React.PureComponent {
  render() {
    const { size } = this.props;

    if (size !== 'default') {
      return (
        <AppSpinnerModalSC>
          <div />
        </AppSpinnerModalSC>
      );
    }
    return (
      <AppLoaderSC>
        <AppSpinnerSC>
          <div />
        </AppSpinnerSC>
      </AppLoaderSC>
    );
  }
}

AppLoader.propTypes = {
  size: PropTypes.string,
};

AppLoader.defaultProps = {
  size: 'default',
};

export default AppLoader;
